/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    TEAM_TYPE_OPEN: 'O',
    TEAM_TYPE_INVITE: 'I'
};



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/constants/teams.js
// module id = 1201
// module chunks = 60